import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";

import { SinglePostJobComp } from "../../components/allPostjobs";
import { AppDispatch } from "../../store";
import { getSinglePostJob } from "../../features/postJob/singlePostJob";

interface SinglePostJobProps {
  loaderContainer?: string;
}

const SinglePostJobPage = ({ loaderContainer }: SinglePostJobProps) => {
  const { jobID } = useParams();

  // console.log(jobID);

  const dispatch = useDispatch<AppDispatch>();

  //   Fetch single post job product
  useEffect(() => {
    dispatch(getSinglePostJob(jobID));
  }, [dispatch, jobID]);

  return <SinglePostJobComp loaderContainer={loaderContainer} />;
};

export default SinglePostJobPage;
